import { Datepicker } from 'vanillajs-datepicker';

/**
 * @see https://github.com/mymth/vanillajs-datepicker/issues/55
 */
export default class DatepickerCustom extends Datepicker {
  setDate(...args) {
    let params;
    if (this.config.maxNumberOfDates > 1 && this.dates.length === this.config.maxNumberOfDates) {
      const lastArg = args[args.length - 1];
      let dates = [...args];
      let options;
      if (
        typeof lastArg === 'object'
        && !Array.isArray(lastArg)
        && !(lastArg instanceof Date)
        && lastArg
      ) {
        options = dates.pop();
      }

      // treat the passed dates only when clear: true option isn't passed
      // (clear: true means to replace all current selection)
      if (!options || !options.clear) {
        if (Array.isArray(dates[0])) {
          dates = dates[0];
        }

        // prepare the dates to pass to the parent method eliminating junk
        params = dates.reduce((dateVals, date) => {
          const dateVal = Datepicker.parseDate(date, this.config.format, this.config.language);
          if (dateVal !== undefined) {
            dateVals.push(dateVal);
          }
          return dateVals;
        }, []);

        // if there's no overlap between current selection and passed date,
        // it means all the dates are to append. Thus, cancel the action here.
        if (params.find(date => this.dates.includes(date)) === undefined) {
          return;
        }

        // append options to the dates to pass to the parent method if it's passed
        if (options) {
          params.push(options);
        }
      }
    }

    super.setDate(...(params || args));
  }
}
